import interceptedAxios from '../../../utils/interceptedAxios'
import { z } from 'zod'

const ZKeyVaultApiResponse = z.object({
  http_status: z.number(),
  error: z.boolean(),
  data: z.record(z.string(), z.string()).default({})
})

export type KeyVaultResponse = z.infer<typeof ZKeyVaultApiResponse>

export async function fetchFromKeyVault (
  keyName: string,
  onSuccess: (successResponse: KeyVaultResponse) => any,
  onFailure: (error: string, httpStatus: number) => any
): Promise<void> {
  const url = `/app-config-service/api/v1/udp/app-key/get-secret?key_name=${keyName}`

  interceptedAxios
    .get(url)
    .then((response) => {
      const parseResponse = ZKeyVaultApiResponse.safeParse(response.data)
      // istanbul ignore else
      if (parseResponse.success) {
        onSuccess(parseResponse.data)
      } else {
        onFailure(parseResponse.error.message, response.status)
      }
    })
    .catch((error) => {
      console.error('Error fetching from Key Vault:', error)
      onFailure('Error fetching from Key Vault', error.status)
    })
}
